import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import '../static/css/profile.scss';

const Home = () => (
  <HelmetProvider>
    <Helmet>
      <title>Zhen Li</title>
      <meta
        name="description"
        content="Creator & Lead Engineer of Replit Agent. Former Google, ByteDance/TikTok."
      />
    </Helmet>
    <div className="profile-container">
      <article className="profile">
        {/* Header */}
        <header className="profile-header">
          <h1>
            {'👋 Hi, I\'m '}
            <a
              href="https://x.com/zhenthebuilder"
              target="_blank"
              rel="noopener noreferrer"
            >
              Zhen
            </a>
            {' (李珎)! 🇨🇳 → 🇺🇸'}
          </h1>

          <div className="roles">
            <p>
              {'👨‍💻 '}
              <strong>Creator & Lead Engineer of Replit Agent</strong>
              {' @ '}
              <a
                href="https://replit.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <em>Replit</em>
              </a>
            </p>
            <p>
              {'🔬 Former '}
              <em>Google</em>
              {', '}
              <em>ByteDance/TikTok</em>
            </p>
            <p>
              🧐 <strong>Expertise</strong>: AI Agents, LLMs, Recommendation Systems, ML at Scale
            </p>
          </div>

          <div className="links">
            <a
              href="https://x.com/zhenthebuilder"
              target="_blank"
              rel="noopener noreferrer"
            >
              [X]
            </a>
            <span> - </span>
            <a
              href="https://linkedin.com/in/zhenthebuilder"
              target="_blank"
              rel="noopener noreferrer"
            >
              [LinkedIn]
            </a>
            <span> - </span>
            <a
              href="https://zhenthebuilder.substack.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              [Substack]
            </a>
            <span> - </span>
            <a
              href="https://github.com/NExPlain"
              target="_blank"
              rel="noopener noreferrer"
            >
              [GitHub]
            </a>
          </div>
        </header>

        {/* Ships Section */}
        <section className="section">
          <h2>🚀 Ships</h2>
          <table>
            <thead>
              <tr>
                <th>When</th>
                <th>What</th>
                <th>Links</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Dec 2025</td>
                <td>Replit launches inside ChatGPT</td>
                <td>
                  <a
                    href="https://blog.replit.com/replit-in-chatgpt"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    [blog]
                  </a>
                </td>
              </tr>
              <tr>
                <td>Dec 2025</td>
                <td>Replit ranked #1 fastest-growing vendor in B2B</td>
                <td>
                  <a
                    href="https://www.linkedin.com/posts/amjadmasad_replit-is-fastest-growing-vendor-in-the-world-activity-7402483964550250497-uhf4"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    [Amjad]
                  </a>
                </td>
              </tr>
              <tr>
                <td>Oct 2025</td>
                <td>a16z AI Spending Report — Replit ranked #3</td>
                <td>
                  <a
                    href="https://a16z.com/the-ai-application-spending-report-where-startup-dollars-really-go/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    [a16z]
                  </a>
                </td>
              </tr>
              <tr>
                <td>Sep 2025</td>
                <td>Replit Agent 3 — 10x more autonomous, I lead the project</td>
                <td>
                  <a
                    href="https://blog.replit.com/introducing-agent-3"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    [blog]
                  </a>
                </td>
              </tr>
              <tr>
                <td>Jul 2025</td>
                <td>Web Search for Agent — I authored the announcement</td>
                <td>
                  <a
                    href="https://blog.replit.com/web-search"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    [blog]
                  </a>
                </td>
              </tr>
              <tr>
                <td>Jun 2025</td>
                <td>Replit hits $100M ARR (10x in 6 months)</td>
                <td>
                  <a
                    href="https://www.growthunhinged.com/p/replit-growth-journey"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    [article]
                  </a>
                </td>
              </tr>
              <tr>
                <td>Feb 2025</td>
                <td>Replit Agent v2 — Major reliability & UX upgrade, I lead the project</td>
                <td>
                  <a
                    href="https://blog.replit.com/agent-v2"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    [blog]
                  </a>
                </td>
              </tr>
              <tr>
                <td>Sep 2024</td>
                <td>
                  <strong>Replit Agent launched</strong>
                  {' — I initiated, prototyped, and lead the project'}
                </td>
                <td>
                  <a
                    href="https://blog.replit.com/introducing-replit-agent"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    [blog]
                  </a>
                  {' '}
                  <a
                    href="https://x.com/karpathy/status/1831776835388285347"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    [Karpathy]
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </section>

        {/* Talks & Writing Section */}
        <section className="section">
          <h2>🎙️ Talks & Writing</h2>
          <table>
            <thead>
              <tr>
                <th>When</th>
                <th>What</th>
                <th>Links</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Nov 2025</td>
                <td>
                  {'📝 '}
                  <strong>Ship Fast Is the Moat</strong>
                  {' — Lessons from Replit Agent'}
                </td>
                <td>
                  <a
                    href="https://zhenthebuilder.substack.com/p/ship-fast-is-the-moat-lessons-from"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    [Substack]
                  </a>
                </td>
              </tr>
              <tr>
                <td>Apr 2025</td>
                <td>🎙️ 洒洒水 — How non-tech people use AI to work for themselves</td>
                <td>
                  <a
                    href="https://www.xiaoyuzhoufm.com/episode/67fc7d4a59699d74dc8afd0f"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    [小宇宙]
                  </a>
                  {' '}
                  <a
                    href="https://podcasts.apple.com/cn/podcast/46-%E6%96%87%E7%A7%91%E7%94%9F%E5%A6%82%E4%BD%95%E7%94%A8ai%E7%BB%99%E8%87%AA%E5%B7%B1%E6%89%93%E5%B7%A5-%E5%AF%B9%E8%AF%9D%E5%85%A8%E7%90%83%E6%9C%80%E7%81%ABai-agent-%E5%88%9B%E5%A7%8B%E4%BA%BA/id1618594430?i=1000703445083"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    [Apple]
                  </a>
                </td>
              </tr>
              <tr>
                <td>Dec 2024</td>
                <td>🎙️ OnBoard! — Deep dive into Coding Agents & OpenAI o3</td>
                <td>
                  <a
                    href="https://www.xiaoyuzhoufm.com/episode/6771a1ea15a5fd520e899302"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    [小宇宙]
                  </a>
                  {' '}
                  <a
                    href="https://podcasts.apple.com/us/podcast/ep-66-深度解读coding-agent与openai-o3-中美agent-创业者-研究员与投资人眼里的未来/id1613083252?i=1000682067471"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    [Apple]
                  </a>
                </td>
              </tr>
              <tr>
                <td>Dec 2024</td>
                <td>🎤 Replit Tech Talk — Agent Architecture Deep Dive</td>
                <td>
                  <a
                    href="https://www.youtube.com/watch?v=dtuwxIJrnS0"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    [YouTube]
                  </a>
                </td>
              </tr>
              <tr>
                <td>Nov 2024</td>
                <td>🎤 Replit Summit Japan</td>
                <td>
                  <a
                    href="https://www.linkedin.com/posts/zhenthebuilder_exciting-share-insights-with-japanese-replit-activity-7265188978830503936-n53L"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    [LinkedIn]
                  </a>
                </td>
              </tr>
              <tr>
                <td>Oct 2024</td>
                <td>🎤 Linkloud Salon @ SaaStr — AI reshaping SaaS globally</td>
                <td>
                  <a
                    href="https://news.qq.com/rain/a/20241013A0643H00"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    [QQ News]
                  </a>
                </td>
              </tr>
              <tr>
                <td>Sep 2024</td>
                <td>📰 硅兔赛跑 — Exclusive interview on Replit Agent</td>
                <td>
                  <a
                    href="https://36kr.com/p/2955060111761544"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    [36氪]
                  </a>
                  {' '}
                  <a
                    href="https://m.163.com/dy/article/JCCB0LPU0511CT9V.html"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    [163]
                  </a>
                </td>
              </tr>
              <tr>
                <td>May 2024</td>
                <td>🎙️ OnBoard! — Will AI Agents replace programmers?</td>
                <td>
                  <a
                    href="https://www.xiaoyuzhoufm.com/episode/66436819251bd96e6c4a1766"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    [小宇宙]
                  </a>
                  {' '}
                  <a
                    href="https://podcasts.apple.com/us/podcast/ep-53-ai-agent%E4%BC%9A%E5%8F%96%E4%BB%A3%E7%A8%8B%E5%BA%8F%E5%91%98%E5%90%97-%E7%A1%AC%E6%A0%B8%E5%AF%B9%E8%AF%9D%E7%A1%85%E8%B0%B7%E9%A1%B6%E5%B0%96%E7%A0%94%E7%A9%B6%E5%91%98%E4%B8%8Eai%E7%8B%AC%E8%A7%92%E5%85%BD-%E8%BD%AF%E4%BB%B6%E5%BC%80%E5%8F%91%E7%9A%84%E6%9C%AA%E6%9D%A5-agent%E7%9A%84%E6%8A%80%E6%9C%AF%E6%9C%AC%E8%B4%A8/id1613083252?i=1000655610468"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    [Apple]
                  </a>
                </td>
              </tr>
              <tr>
                <td>May 2023</td>
                <td>📝 8 projects in 11 months — just ship more</td>
                <td>
                  <a
                    href="https://zhenthebuilder.substack.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    [Substack]
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </section>

        {/* Highlights Section */}
        <section className="section">
          <h2>🔦 Highlights</h2>

          <h3>🎓 Education</h3>
          <ul>
            <li>
              <strong>B.E. in Software Engineering</strong>
              {' at '}
              <em>Beihang University</em>
              {' (北京航空航天大学)'}
              <ul>
                <li>
                  {'Ranked '}
                  <strong>#1</strong>
                  {' in class of 136'}
                </li>
                <li>National Scholarship recipient</li>
                <li>Graduated with honors</li>
                <li>President of Microsoft Student Technology Club</li>
              </ul>
            </li>
          </ul>

          <h3>👨‍💻 Experience</h3>
          <ul>
            <li>
              <strong>Staff AI Engineer</strong>
              {' at '}
              <em>Replit</em>
              <ul>
                <li>
                  {'Creator & Lead Engineer of '}
                  <a
                    href="https://replit.com/agent"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Replit Agent
                  </a>
                </li>
                <li>Grew Agent to $250M+ ARR (10x in 6 months)</li>
              </ul>
            </li>
            <li>
              <strong>Machine Learning Engineer</strong>
              {' at '}
              <em>ByteDance</em>
              <ul>
                <li>Built ML systems for TikTok recommendation and ads</li>
              </ul>
            </li>
            <li>
              <strong>Senior Software Engineer</strong>
              {' at '}
              <em>Google</em>
              <ul>
                <li>User Modeling & Stateful Search</li>
                <li>ML for Google Search, Discover, and News</li>
              </ul>
            </li>
            <li>
              <strong>Research Intern</strong>
              {' at '}
              <em>Microsoft Research Asia</em>
              <ul>
                <li>
                  Distributed graph computation (
                  <a
                    href="https://www.usenix.org/conference/nsdi17/technical-sessions/presentation/xiao"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Tux²
                  </a>
                  )
                </li>
              </ul>
            </li>
          </ul>
        </section>
      </article>
    </div>
  </HelmetProvider>
);

export default Home;
